import { UserRowRoleType } from '@modules/users/store/types';
import {
  renderPermissionModuleRowCell,
  renderPermissionOperationRowCell,
} from '@modules/users/utils';
import { GridColDef } from '@mui/x-data-grid-pro';

export const getPermissionsColumns = (): GridColDef[] => {
  return [
    {
      field: 'module',
      headerName: 'Module',
      minWidth: 200,
      flex: 1,
      type: 'string',
      sortingOrder: ['asc', 'desc'],
      renderCell: renderPermissionModuleRowCell,
    },
    {
      field: 'adminOperation',
      headerName: UserRowRoleType.Admin,
      minWidth: 150,
      type: 'string',
      headerAlign: 'center',
      sortable: false,
      renderCell: renderPermissionOperationRowCell,
    },
    {
      field: 'memberOperation',
      headerName: UserRowRoleType.Member,
      minWidth: 150,
      type: 'string',
      headerAlign: 'center',
      sortable: false,
      renderCell: renderPermissionOperationRowCell,
    },
  ];
};
